import * as React from 'react';
import { SVGProps } from 'react';

const IconKernFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 7c1.855 0 3.628-.31 5.012-.886.335-.14.67-.304.988-.498V13.5c0 1.38-2.686 2.5-6 2.5s-6-1.12-6-2.5V5.615c.318.195.653.36.988.499C4.372 6.69 6.145 7 8 7ZM2 2.5C2 1.12 4.686 0 8 0s6 1.12 6 2.5S11.314 5 8 5 2 3.88 2 2.5Z" />
  </svg>
);
export default IconKernFilledSizeS;
